import React from 'react'
import {fire} from "../../firebase/config";

import Section1 from './Section1'
import Section2 from './Section2'

function FirstPage() {
    return (
        <div>
            <Section1/>
           
        </div>
    )
}

export default FirstPage
